import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IEstelamWithShomarehBimehNamehAndShomarehEntezamiQuery } from '../Queries/IEstelamWithShomarehBimehNamehAndShomarehEntezamiQuery';

export const getEstelamWithShomarehBimehNamehAndShomarehEntezami = createAsyncThunk(
  'BimehNameh/EstelamWithShomarehBimehNamehAndShomarehEntezami',
  async (query: IEstelamWithShomarehBimehNamehAndShomarehEntezamiQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehMarkazi.EstelamWithShomarehBimehNamehAndShomarehEntezami}`,
      params: query,
    });
  }
);
